import React, { useEffect, useRef } from 'react';
import { STATUS_TEXT } from '../../utils/nonoSolver';

// Pointer position inside a canvas, in CSS pixels
export const canvasPoint = (canvas, e) => {
  const rect = canvas.getBoundingClientRect();
  return { x: e.clientX - rect.left, y: e.clientY - rect.top };
};

// Window keydown for the tracers: Enter applies, Escape cancels, `onKey` gets everything else.
// While a form field has focus only Enter and Escape get through.
export function useTracerKeys({ apply, onCancel, onKey }) {
  const latest = useRef();
  latest.current = { apply, onCancel, onKey };
  useEffect(() => {
    const handler = (e) => {
      const { apply, onCancel, onKey } = latest.current;
      const typing = ['INPUT', 'TEXTAREA', 'SELECT'].includes(document.activeElement?.tagName);
      if (typing && e.key !== 'Enter' && e.key !== 'Escape') return;
      if (e.key === 'Enter') { e.preventDefault(); apply(); }
      else if (e.key === 'Escape') { e.preventDefault(); onCancel(); }
      else onKey(e);
    };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, []);
}

export function TracerCanvas({ canvasRef, drag, onPointerDown, onPointerMove }) {
  return (
    <canvas
      ref={canvasRef}
      className="nn-canvas nn-tracer-canvas"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={() => { drag.current = null; }}
      onPointerCancel={() => { drag.current = null; }}
      onContextMenu={e => e.preventDefault()}
    />
  );
}

export function TracerStatus({ analysis }) {
  return (
    <div className={`nn-status nn-status-${analysis.status}`}>
      {STATUS_TEXT[analysis.status]}
      {analysis.unresolved > 0 && analysis.status !== 'empty' && <span> · {analysis.unresolved} ratkeamatonta ruutua</span>}
    </div>
  );
}

export function TracerActions({ onCancel, apply }) {
  return (
    <div className="nn-row">
      <button className="btn-secondary" onClick={onCancel}>Peruuta <kbd>Esc</kbd></button>
      <button className="btn-primary" onClick={apply}>Käytä <kbd>Enter</kbd></button>
    </div>
  );
}
